module.exports = __webpack_public_path__ + "static/media/sam.6643cf57.jpg";